/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
const PENDING_SYNC_STORAGE_KEY = 'crystalRarityPendingSyncBatch';
const PENDING_SYNC_TTL_MS = 1000 * 60 * 60;

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));
    this.isSyncingDraftOrder = false;
    this.isRollingBackSyncedBatch = false;

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

    $(document).on('submit', '.ajax-cart__form', function (e) {
      const context = window.PXUTheme.jsAjaxCart.getDraftOrderContext();

      if (!context) {
        return true;
      }

      e.preventDefault();

      if (this && typeof this.reportValidity === 'function' && !this.reportValidity()) {
        return false;
      }

      const $checkoutButton = $(this).find('button[name="checkout"]').first();
      window.PXUTheme.jsAjaxCart.syncCartToDraftOrder($checkoutButton);
      return false;
    });

    $(window).on('pageshow.crystalRarityDraftSyncAjaxCart', function () {
      window.PXUTheme.jsAjaxCart.rollbackPendingSyncBatchIfNeeded().finally(function () {
        window.PXUTheme.jsAjaxCart.renderDraftOrderActions();
      });
    });

    this.rollbackPendingSyncBatchIfNeeded().finally(function () {
      window.PXUTheme.jsAjaxCart.renderDraftOrderActions();
    });
  },
  renderDraftOrderActions: function (message, isError) {
    const context = this.getDraftOrderContext();
    const $container = $('.ajax-cart [data-draft-order-actions]');
    const $message = $('.ajax-cart [data-draft-order-message]');
    const activeTemplate = $container.data('draft-order-active-template') || 'Part of your live sale order: *ORDER_NAME*.';

    if (!context) {
      this.updateCartDisplayForDraftOrder(false);
      $container.hide();
      this.renderCombinedSubtotal(null);
      return;
    }

    this.updateCartDisplayForDraftOrder(true);
    $container.show();
    const orderLabel = context.orderName || context.email || 'this customer';
    const defaultMessage = activeTemplate.replace('*ORDER_NAME*', orderLabel);
    $message.text(message || defaultMessage);
    $message.css('color', isError ? '#c00' : '#111');
    this.loadDraftOrderSummary();
  },
  updateCartDisplayForDraftOrder: function (hasDraftOrderContext) {
    const hasCartItems = $('.ajax-cart__list .ajax-cart__product').length > 0;

    if (hasDraftOrderContext) {
      $('.ajax-cart__empty-cart-message').addClass('is-hidden');
      $('.ajax-cart__form').removeClass('is-hidden');
      return;
    }

    if (!hasCartItems) {
      $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
      $('.ajax-cart__form').addClass('is-hidden');
    }
  },
  formatMoneyCents: function (cents) {
    const safeCents = Number.isFinite(cents) ? Math.round(cents) : 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(safeCents, $('body').data('money-format'));
    }
    return (safeCents / 100).toFixed(2);
  },
  parseAmountToCents: function (amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) {
      return 0;
    }
    return Math.round(value * 100);
  },
  renderCombinedSubtotal: function (draftOrder) {
    const draftSubtotalCents = draftOrder ? this.parseAmountToCents(draftOrder.subtotalPrice || draftOrder.totalPrice) : 0;
    $('.ajax-cart__subtotal[data-cart-subtotal-cents]').each(function () {
      const rawValue = $(this).attr('data-cart-subtotal-cents');
      const cartSubtotalCents = Number(rawValue);
      const safeCartSubtotal = Number.isFinite(cartSubtotalCents) ? Math.round(cartSubtotalCents) : 0;
      const combinedCents = safeCartSubtotal + draftSubtotalCents;
      const formatted = window.PXUTheme.jsAjaxCart.formatMoneyCents(combinedCents);
      const $money = $(this).find('.money').first();

      if (!$money.length) {
        return;
      }

      $money.html(formatted);

      if (window.PXUTheme.currencyConverter && typeof window.PXUTheme.currencyConverter.update === 'function') {
        window.PXUTheme.currencyConverter.update($money[0]);
      }
    });
  },
  getDraftOrderContext: function () {
    const draftOrderFlow = window.CrystalRarityDraftOrder;
    const context = draftOrderFlow && draftOrderFlow.readContext ? draftOrderFlow.readContext() : null;
    return context || null;
  },
  getDraftOrderSummaryEndpoint: function (context) {
    const workerUrl = String(context && context.workerUrl || '').replace(/\/$/, '');
    const draftOrderId = encodeURIComponent(context && context.draftOrderId || '');
    if (!workerUrl || !draftOrderId) {
      return '';
    }
    return workerUrl + '/draft-orders/' + draftOrderId + '/summary';
  },
  getDraftOrderRollbackEndpoint: function (context) {
    const workerUrl = String(context && context.workerUrl || '').replace(/\/$/, '');
    const draftOrderId = encodeURIComponent(context && context.draftOrderId || '');
    if (!workerUrl || !draftOrderId) {
      return '';
    }
    return workerUrl + '/draft-orders/' + draftOrderId + '/rollback-synced-batch';
  },
  readPendingSyncBatch: function () {
    try {
      const raw = window.localStorage.getItem(PENDING_SYNC_STORAGE_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw);
    } catch (_error) {
      return null;
    }
  },
  clearPendingSyncBatch: function () {
    try {
      window.localStorage.removeItem(PENDING_SYNC_STORAGE_KEY);
    } catch (_error) {}
  },
  rollbackPendingSyncBatchIfNeeded: function () {
    const context = this.getDraftOrderContext();
    const pending = this.readPendingSyncBatch();
    const now = Date.now();

    if (!context || !pending || !pending.syncBatchId || !pending.draftOrderId) {
      return Promise.resolve();
    }

    if (String(context.draftOrderId || '') !== String(pending.draftOrderId || '')) {
      this.clearPendingSyncBatch();
      return Promise.resolve();
    }

    if (!pending.savedAt || now - Number(pending.savedAt) > PENDING_SYNC_TTL_MS) {
      this.clearPendingSyncBatch();
      return Promise.resolve();
    }

    const endpoint = this.getDraftOrderRollbackEndpoint(context);
    if (!endpoint || this.isRollingBackSyncedBatch) {
      return Promise.resolve();
    }

    this.isRollingBackSyncedBatch = true;
    let shouldClearPending = false;
    const workerSecret = context.workerSecret ? context.workerSecret : '';

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Worker-Secret': workerSecret
      },
      body: JSON.stringify({
        syncBatchId: String(pending.syncBatchId)
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success) {
          throw new Error(data && data.message ? data.message : 'Unable to rollback synced live sale items.');
        }
        return data;
      });
    }).then(function () {
      shouldClearPending = true;
    }).catch(function () {
      return null;
    }).finally(function () {
      window.PXUTheme.jsAjaxCart.isRollingBackSyncedBatch = false;
      if (shouldClearPending) {
        window.PXUTheme.jsAjaxCart.clearPendingSyncBatch();
      }
    });
  },
  renderDraftOrderSummary: function (lineItems) {
    const $summary = $('.ajax-cart [data-draft-order-summary]');
    const $list = $('.ajax-cart [data-draft-order-summary-list]');
    const items = Array.isArray(lineItems) ? lineItems : [];

    if (!$summary.length || !$list.length || !items.length) {
      $summary.hide();
      $list.empty();
      return;
    }

    const rows = items.map(function (item) {
      const title = String(item && item.title || 'Item');
      const quantity = Number(item && item.quantity || 0);
      const lineText = (quantity > 0 ? quantity + ' x ' : '') + title;
      const escapedText = $('<div>').text(lineText).html();
      return '<li style="border:1px solid #e7e2db;background:#fff;padding:8px 10px;">' + escapedText + '</li>';
    });

    $list.html(rows.join(''));
    $summary.show();
  },
  loadDraftOrderSummary: function () {
    const context = this.getDraftOrderContext();
    const $container = $('.ajax-cart [data-draft-order-actions]');
    const workerSecret = context && context.workerSecret ? context.workerSecret : '';
    const summaryEndpoint = this.getDraftOrderSummaryEndpoint(context);

    if (!context || !summaryEndpoint) {
      this.renderDraftOrderSummary([]);
      this.renderCombinedSubtotal(null);
      return Promise.resolve();
    }

    return fetch(summaryEndpoint, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Worker-Secret': workerSecret
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.success || !data.draftOrder) {
          throw new Error($container.data('draft-order-sync-error-text') || 'Unable to load draft order items.');
        }

        window.PXUTheme.jsAjaxCart.renderDraftOrderSummary(data.draftOrder.lineItems || []);
        window.PXUTheme.jsAjaxCart.renderCombinedSubtotal(data.draftOrder || null);
      });
    }).catch(function () {
      window.PXUTheme.jsAjaxCart.renderDraftOrderSummary([]);
      window.PXUTheme.jsAjaxCart.renderCombinedSubtotal(null);
    });
  },
  syncCartToDraftOrder: function ($button) {
    const draftOrderFlow = window.CrystalRarityDraftOrder;
    const $checkoutButton = $button && $button.length ? $button : $('.ajax-cart__button-wrapper button[name="checkout"]').first();
    const context = this.getDraftOrderContext();
    const syncBatchId = window.PXUTheme.jsCart && window.PXUTheme.jsCart.createSyncBatchId
      ? window.PXUTheme.jsCart.createSyncBatchId()
      : 'sync-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);

    if (!draftOrderFlow || this.isSyncingDraftOrder) {
      return;
    }

    this.isSyncingDraftOrder = true;
    $checkoutButton.attr('disabled', 'disabled');
    const $container = $('.ajax-cart [data-draft-order-actions]');
    const syncingText = $container.data('draft-order-syncing-text') || 'Syncing your cart items to your live sale order. Please wait...';
    this.renderDraftOrderActions(syncingText);

    draftOrderFlow.syncCartToDraftOrder({
      syncBatchId: syncBatchId,
      onComplete: function () {
        if (typeof window.PXUTheme.jsCart !== 'undefined' && window.PXUTheme.jsCart.renderDraftOrderActions) {
          window.PXUTheme.jsCart.renderDraftOrderActions();
        }

        window.PXUTheme.jsAjaxCart.updateView();
      }
    }).then(function (data) {
      try {
        if (!data.skippedCartSync && context && context.draftOrderId && (data.syncBatchId || syncBatchId)) {
          window.localStorage.setItem(PENDING_SYNC_STORAGE_KEY, JSON.stringify({
            draftOrderId: String(context.draftOrderId || ''),
            syncBatchId: String(data.syncBatchId || syncBatchId),
            savedAt: Date.now()
          }));
        }
      } catch (_error) {}
      window.location.href = data.invoiceUrl || context.invoiceUrl;
    }).catch(function (error) {
      const errorText = $container.data('draft-order-sync-error-text') || 'Unable to sync your cart to the live sale order.';
      window.PXUTheme.jsAjaxCart.renderDraftOrderActions(error.message || errorText, true);
      try {
        window.localStorage.removeItem(PENDING_SYNC_STORAGE_KEY);
      } catch (_error) {}
    }).finally(function () {
      window.PXUTheme.jsAjaxCart.isSyncingDraftOrder = false;
      $checkoutButton.removeAttr('disabled');
    });
  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);
        window.PXUTheme.jsAjaxCart.renderDraftOrderActions();

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);
        window.PXUTheme.jsAjaxCart.renderDraftOrderActions();

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    return window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {
      const itemList = $(html.content).find('.ajax-cart__list');
      const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
      const context = window.PXUTheme.jsAjaxCart.getDraftOrderContext();

      $('.ajax-cart__list').replaceWith(itemList);
      $('.ajax-cart__details-wrapper').replaceWith(cartDetails);

      if (options.item_count > 0) {
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else if (context) {
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }

      window.PXUTheme.jsAjaxCart.renderDraftOrderActions();
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
    $(window).off('pageshow.crystalRarityDraftSyncAjaxCart');
  }
}

/******/ })()
;
